import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { segmentIdentifyUser } from '../../actions/AuthActions';

class Home extends React.Component {

  do() {
    const { dispatch, apiAuth, history, hasDashboard } = this.props
    if (!apiAuth.isSignedIn) return dispatch(push('/logout'))
    const defaultLocation = hasDashboard ? '/dashboard' : '/sites'
    this.props.history.replace(defaultLocation)
  }

  componentDidMount() {
    this.do()
  }

  componentDidUpdate() {
    this.do()
  }

  render = () => null

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    hasDashboard: store.apiAuth && store.apiAuth.user && store.apiAuth.user.has_dashboard,
  }),
)(Home)



// WEBPACK FOOTER //
// ./src/containers/home/index.js